import type { ReactNode } from "react";

type PlotTooltipProps = {
	plotName?: string | null;
	plotNumber?: number | null;
	treatmentNumber?: string | null;
	chamberNumber?: string | null;
	hasT54?: boolean;
	hasT32?: boolean;
	/** Rendered immediately after the plot name, on the same line (e.g. a selection checkmark). */
	nameSuffix?: ReactNode;
	extra?: ReactNode;
};

export function PlotTooltip({
	plotName,
	plotNumber,
	treatmentNumber,
	chamberNumber,
	hasT54,
	hasT32,
	nameSuffix,
	extra,
}: PlotTooltipProps) {
	return (
		<>
			<span className="font-medium">{plotName}</span>
			{nameSuffix}
			{plotNumber != null && (
				<>
					<br />
					<span className="text-gray-500 text-xs">Plot #{plotNumber}</span>
				</>
			)}
			{treatmentNumber && (
				<>
					<br />
					<span className="text-gray-500 text-xs">Treatment {treatmentNumber}</span>
				</>
			)}
			{chamberNumber && (
				<>
					<br />
					<span className="text-gray-500 text-xs">Chamber {chamberNumber}</span>
				</>
			)}
			{(hasT54 || hasT32) && (
				<>
					<br />
					<span className="text-gray-500 text-xs">
						{[hasT54 && "T54", hasT32 && "T32"].filter(Boolean).join(" · ")}
					</span>
				</>
			)}
			{extra}
		</>
	);
}
